// показатели документы
import React from 'react';
import {
  Button, Card, Col, Form, Row, Badge,
} from 'react-bootstrap';
import { PlusLg } from 'react-bootstrap-icons';
import { makeUID } from '../../helpers';

import { floatRenderer } from '../../services/formatSvc';
import { FloatFlexibleInput } from '../common/MonetaryFloatInput';
import Required from '../Required';
import './styling.less';
import PcValsDocumentEdit2 from './PcValsDocumentEdit2';

const needDoc = [
  'Количество исследователей в возрасте до 39 лет, трудоустроенных в УрФУ по основному месту работы за счет выделенных целевых средств, рассчитанное по среднесписочной численности',
  'Количество исследователей в возрасте до 39 лет, трудоустроенных в УрФУ по основному месту работы за счет выделенных целевых средств (рассчитано по среднесписочной численности)',
];

export default function UniqueResultCard({
  data,
  onResultChange,
  requestFileRemove,
  canEdit,
  letters,
  year,
  projPcOriginId,
  portfId,
  name,
}) {
  const handleFileChange = (fileHash, field, value) => {
    const updatedFiles = data.map((f) =>
      (f.hash === fileHash ? { ...f, [field]: value } : f));
    onResultChange(updatedFiles);
  };

  const handleFileAdd = () => {
    const newFile = {
      id: null,
      title: undefined,
      type: 'link',
      hash: makeUID(5),
      year,
      projPcOriginId,
    };
    onResultChange([...data, newFile]);
  };

  const handleFileRemove = async (id, hash) => {
    if (id) {
      await requestFileRemove(data.id, id);
    }
    const updatedFiles = data.filter((f) => {
      if (f.hash) return f.hash !== hash;

      return f.id !== id;
    });
    onResultChange(updatedFiles);
  };

  const isReq = (value) => {
    if (portfId) return false; ///P2030-526
    if (!portfId) return true;
    if (value == needDoc[0]) return true;
    if (value == needDoc[1]) return true;
    return false;
  };

  return (
    <div className="mb-4">
      <Card className="mb-4">
        <Card.Header className="p-3">
          Подтверждающие документы
        </Card.Header>
        <Card.Body className="p-4">
          {data?.map((f) => (
            <PcValsDocumentEdit2
              file={f}
              key={f.hash}
              onFileChange={handleFileChange}
              onFileRemove={handleFileRemove}
              canEdit={canEdit}
            />
          ))}
        </Card.Body>
      </Card>
      {true && (
        <Button variant="outline-primary" onClick={handleFileAdd}>
          <PlusLg className="me-1 mb-1" />
          Добавить документ
        </Button>
      )}
    </div>
  );
}

const cardHeaderColor = '#F7F7F7';
const styledLabel = { color: '#7F7F7F', fontWeight: '600' };
